<template>
  <div class='merchants'>
    <img class="title" src="@/assets/joinus/merchants/kv.png" alt="">
		<div class="box">
      <div class="tit-text">在线加盟</div>
			<div class="inp1">
				<el-input v-model="form.name" placeholder="姓名"></el-input>
        <el-input v-model="form.phone" maxlength="11" placeholder="手机号码"></el-input>
			</div>
			<div class="inp2">
        <el-cascader
					v-model="form.value"
					:options="cityList"
					popper-class="popperinp2"></el-cascader>
			</div>
			<div class="btn">
				<el-button type="primary" @click="submit">快速加盟</el-button>
			</div>

		</div>
    <img class="image" src="@/assets/joinus/merchants/1.jpg" alt="">
  </div>
</template>

<script>
import '@/util/area'
import { collectInfo } from "@/api/collectInfo.js";
import { isPhone } from '@/util/utils.js'
export default {
  name: 'Merchants',
  components: {
  },
  props: {
    userInfo: {}
  },
  data() {
    return {
			textarea: '',
			form: {
				name: '',
				phone: '',
        value: []
			},
      cityList: [],
      value1: '',
      value: ''
    }
  },
  computed: { },
  watch: {},
  created() {
		this.getCity()
  },
  mounted() {
    console.log(!('id' in this.userInfo))
  },
  methods: {
		getCity() {
      const allCityInformation = city()
      this.cityList = this.traverse(86, allCityInformation)
    },
		traverse(key, obj) {
      const objes = obj[key]
      const arr = []
      for (const i in objes) {
        arr.push({
          label: objes[i],
          value: i,
          children: obj[i] && this.traverse(i, obj)
        })
      }
      return arr
    },
    submit() {
      if (!('id' in this.userInfo)) {
        this.$emit('needLogin', true)
        return
      }
      if (!this.form.name) {
        this.$message('请输入姓名')
        return false
      }
      if (!isPhone(this.form.phone)) {
        this.$message('手机号码格式错误')
        return false
      }
      const obj = this.cityList.filter(item => item.value === this.form.value[0])[0]
      const province = obj.label
      const obj1 = obj.children.filter(item => item.value === this.form.value[1])[0]
      let city = obj1.label
      const district = obj1.children.filter(item => item.value === this.form.value[2])[0].label
      const user_id = JSON.parse(localStorage.getItem('giftsUser')).id
      const data = {
        info_type: 2,
        name: this.form.name,
        mobile: this.form.phone,
        province,
        city,
        district,
        address: '',
        requirement: '',
        descr: '',
        user_id
      }
      collectInfo(data).then(res => {
        console.log(res)
        if (res.result == 1) {
          this.form = {
            name: '',
            phone: '',
            value: [],
            textarea: ''
          }
          this.$message({message: res.msg, type: 'success'})
        } else {
          this.$message(res.msg)
        }
      })
    },
  }
}
</script>
<style lang='less' scoped>
.merchants {
  position: relative;
	max-width: 1920px;
	width: 100%;
  margin: 0 auto;
	.title{
		width: 100%;
		height: 822px;
	}
	.bot{
		position: absolute;
		width: 100%;
		height: 828px;
		top: 540.5px;
		left: 0;
	}

  .box{
		position: absolute;
		top: 165px;
		right: 241px;
		z-index: 4;
		width: 720px;
		height: 538px;
		background: #FFFFFF;
		border-radius: 25px;
		.tit-text{
			margin-top: 60px;
			font-size: 48px;
			font-family: FZLanTingHeiS-DB-GB;
			font-weight: 400;
			color: #4E8B46;
		}
		.tit-desc{
			margin-top: 36px;
			font-size: 24px;
			font-family: FZLanTingHeiS-R-GB;
			font-weight: 400;
			color: #414141;
		}
		.inp1{
			display: flex;
			justify-content: space-between;
			margin-top: 52px;
			width: 100%;
			box-sizing: border-box;
			padding: 0 50px;
			height: 50px;
			/deep/.el-input{
				width: 295px;
				height: 100%;
				.el-input__inner{
					width: 100%;
					height: 100%;
					border-radius: 25px;
					border: 1px solid #B8D4B4;
					background: #F5F8F4;
          font-size: 24px;
          &::placeholder {
							font-size: 24px;
							font-family: FZLanTingHeiS-R-GB;
							font-weight: 400;
							color: #ccc;
						}
				}
			}
		}

		.inp2{
			display: flex;
			justify-content: space-between;
			margin-top: 50px;
			width: 100%;
			box-sizing: border-box;
			padding: 0 50px;
			height: 50px;
			/deep/.el-cascader{
				width: 100%;
				height: 100%;
				.el-input{
					width: 100%;
					height: 100%;
					.el-input__inner{
						width: 100%;
						height: 100%;
						border-radius: 25px;
						border: 1px solid #B8D4B4;
						background: #F5F8F4;
            font-size: 24px;
            &::placeholder {
							font-size: 24px;
							font-family: FZLanTingHeiS-R-GB;
							font-weight: 400;
							color: #ccc;
						}
					}
					.el-input__suffix{
            right: 16px;
					}
					.el-icon-arrow-down {
						position: relative;
						&:before {
							content: '';
							border-top:14px solid #B8D4B4;
							border-left:7px solid transparent;
							border-right:7px solid transparent;
							border-bottom:14px solid transparent;
							position: absolute;
							top: 17.5px;
							left: 25%;
						}
						&.is-reverse {
							transform: rotateZ(-180deg)
						}
					}
				}
			}
			/deep/.el-select{
				width: 295px;
				height: 100%;
				.el-input{
					width: 100%;
					height: 100%;
					.el-input__inner{
						width: 100%;
						height: 100%;
						border-radius: 25px;
						border: 1px solid #B8D4B4;
						background: #F5F8F4;
            &::placeholder {
							font-size: 24px;
							font-family: FZLanTingHeiS-R-GB;
							font-weight: 400;
							color: #ccc;
						}
					}
					.el-input__suffix{
            right: 16px;
					}
					.el-icon-arrow-up {
						position: relative;
						&:before {
							content: '';
							border-top:14px solid transparent;
							border-left:7px solid transparent;
							border-right:7px solid transparent;
							border-bottom:14px solid #B8D4B4;
							position: absolute;
							top: 3.5px;
							left: 25%;
						}
					}
				}
			}
		}

    .content{
			position: relative;
			margin: 0 auto;
			margin-top: 32px;
			width: 620px;
			height: 120px;
			/deep/.el-textarea{
				position: absolute;
				top: 0;
				left: 0;
				width: 620px;
				height: 120px;
				.el-textarea__inner{
					height: 100% !important;
					font-size: 18px;
					background: #F5F8F4;
					border: 1px solid #B8D4B4;
					border-radius: 25px 25px 25px 25px;
					outline: none;
					resize: none;
          &::placeholder {
							font-size: 24px;
							font-family: FZLanTingHeiS-R-GB;
							font-weight: 400;
							color: #ccc;
						}
				}
			}
		}

		.btn{
			position: relative;
			height: 60px;
			margin-top: 50px;
			button{
				position: absolute;
				width: 620px;
				height: 100%;
				top: 0;
				left: 50px;
			}
			/deep/.el-button--primary{
				background: #4E8B46;
				border-color: #4E8B46;
				border-radius: 25px 25px 25px 25px;
			}
			/deep/.el-button{
				font-size: 32px;
			}
		}
		
	}
  .image {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    vertical-align: top;
  }
}

</style>
<style lang="less">
.popperinp2 {
	margin-top: 5px!important;
	background: #F5F8F4;
	border: 1px solid #B8D4B4;
	border-radius: 25px;
	.el-select-dropdown__item{
    color: #999999;
		font-weight: normal;
		text-align: center;
		height: 47px;
		line-height: 47px;
	}
	.selected{
		color: #999999;
		font-weight: normal;
	}
	.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    font-size: 24px;
		color: #4E8B46;
		font-weight: 400;
		background: none;
	}
	.el-cascader-node:not(.is-disabled){
		height: 47px;
		line-height: 47px;
	}
	.el-cascader-menu{
		font-size: 24px;
		color: #999;
	}
	.el-cascader-node:not(.is-disabled):focus, .el-cascader-node:not(.is-disabled):hover{
		background: none;
	}
	.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
		color: #4E8B46;
		font-weight: 400;
		background: none;
	}
	.popper__arrow {
		display: none;
	}
}
</style>
